import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  IconButton,
  Autocomplete,
} from '@mui/material';
import { mentalHealthDiagnoses } from '../data/mentalHealthDiagnoses';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const DiagnosisManager = ({ diagnoses = [], setDiagnoses }) => {
  const [newDiagnosis, setNewDiagnosis] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);

  const addDiagnosis = () => {
    if (editingIndex !== null) {
      const updatedDiagnoses = [...diagnoses];
      updatedDiagnoses[editingIndex] = newDiagnosis;
      setDiagnoses(updatedDiagnoses);
      setEditingIndex(null);
    } else {
      setDiagnoses([...diagnoses, newDiagnosis]);
    }
    setNewDiagnosis('');
  };

  const editDiagnosis = (index) => {
    setNewDiagnosis(diagnoses[index]);
    setEditingIndex(index);
  };

  const deleteDiagnosis = (index) => {
    const updatedDiagnoses = diagnoses.filter((_, i) => i !== index);
    setDiagnoses(updatedDiagnoses);
  };

  return (
    <Box>
      <Typography variant='h6'>Diagnosis</Typography>

      <Autocomplete
        freeSolo
        options={mentalHealthDiagnoses.map(
          (option) => `${option.code} - ${option.name}`
        )}
        value={newDiagnosis}
        onChange={(event, newValue) => setNewDiagnosis(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            label='Add or Edit Diagnosis'
            placeholder='E.g. F32.0 - Mild Depressive Episode'
            value={newDiagnosis}
            onChange={(e) => setNewDiagnosis(e.target.value)}
            sx={{ marginBottom: 2 }}
          />
        )}
      />

      <Button variant='contained' color='primary' onClick={addDiagnosis}>
        {editingIndex !== null ? 'Update Diagnosis' : 'Add Diagnosis'}
      </Button>

      <Box sx={{ marginTop: 3 }}>
        {diagnoses.map((diagnosis, index) => (
          <Paper
            key={index}
            sx={{
              padding: 2,
              marginBottom: 1,
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Typography>{diagnosis}</Typography>
            <Box>
              <IconButton color='primary' onClick={() => editDiagnosis(index)}>
                <EditIcon />
              </IconButton>
              <IconButton
                color='secondary'
                onClick={() => deleteDiagnosis(index)}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default DiagnosisManager;
